import { useEffect } from 'react'
import Header from '../../modules/apps/components/Header'
import Footer from '../../modules/apps/components/Footer'
import { Link } from 'react-router-dom'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import CtaSection from '../../modules/apps/components/about/CtaSection'
import TrajectorySection from '../../modules/apps/components/about/TrayectorySection'
import MissionVisionSection from '../../modules/apps/components/about/MissionVisionSection'
import ValuesSection from '../../modules/apps/components/about/ValuesSection'

const AboutPage = () => {

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <Header />

      <div className="bg-white">

        <div className="position-relative">

          <picture className="w-100 h-100">
            <source
              srcSet={toAbsoluteUrl('/images/banner/banner-about-talara-desktop.webp')}
              media="(min-width: 1024px)"
              type="image/webp"
            />
            <source
              srcSet={toAbsoluteUrl('/images/banner/banner-about-talara-tablet.webp')}
              media="(min-width: 640px)"
              type="image/webp"
            />
            <img
              src={toAbsoluteUrl('/images/banner/banner-about-talara-mobile.webp')}
              alt="Alquiler de autos"
              className="w-100 object-fit-cover about-banner"
              style={{
                objectFit: "cover",
                objectPosition: "center"
              }}
              loading="eager"
            />
          </picture>

          {/* overlay */}
          <div className="hero-overlay position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center text-center">

            <div className="container">

              <h1 className="fw-bold display-2 text-white">
                Conoce Talara Rent a Car
              </h1>

              <p className="fs-3 text-white">
                Tu Socio de Confianza para alquilar vehículos como autos, camionetas, vans y más en <span className='fw-bold' style={{ color: "#d22222" }}>Talara</span>
              </p>

              <div className="mt-4">
                <Link
                  to="/"
                  className="btn fw-bold px-4 py-3"
                  style={{ backgroundColor: "#d22222", color: "white" }}
                >
                  Cotizar ahora
                </Link>
              </div>

            </div>

          </div>

        </div>

      </div>

      <TrajectorySection />
      <MissionVisionSection />
      <ValuesSection />

      <CtaSection />

      <Footer />

      <style>
        {`
        .about-banner{
          height:400px;
        }

        @media (min-width:992px){
          .about-banner{
            height:550px;
          }
        }

        @media (min-width:1200px){
          .about-banner{
            height:100vh;
          }
        }

        .hero-overlay{
          background: linear-gradient(
            rgba(0,0,0,0.45),
            rgba(0,0,0,0.55)
          );
        }

        .hero-title{
          font-size:2rem;
          line-height:1.2;
        }

        @media (min-width:768px){
          .hero-title{
            font-size:3rem;
          }
        }

        @media (min-width:1200px){
          .hero-title{
            font-size:4rem;
          }
        }

        .hero-subtitle{
          max-width:700px;
          margin:auto;
          font-size:1rem;
        }

        @media (min-width:768px){
          .hero-subtitle{
            font-size:1.2rem;
          }
        }
        `}
      </style>

    </>
  )
}

export default AboutPage